import workerXhr from 'workerXhr';
import settings from '../../settings';

const CALLBACK_URL = `${settings.api}/api/worker-callback/videos`;

// dry_run:true — parsea el CSV y devuelve conteos/preview SIN encolar nada.
export async function previewBatchFromCsv(csvText, options = {}) {
	const res = await workerXhr.post('/batches/from-csv', {
		csv_text: csvText,
		batch_id: options.batchId,
		callback_url: CALLBACK_URL,
		priority_strategy: options.priorityStrategy || 'active_students_desc',
		exclude_material_ids: options.excludeMaterialIds || undefined,
		limit: options.limit || undefined,
		voice_preset: options.voicePreset || undefined,
		dry_run: true,
	});
	return res.data;
}

// dry_run:false — encola de verdad los items ya revisados.
export async function submitBatchFromCsv(csvText, options = {}) {
	const res = await workerXhr.post('/batches/from-csv', {
		csv_text: csvText,
		batch_id: options.batchId,
		callback_url: CALLBACK_URL,
		priority_strategy: options.priorityStrategy || 'active_students_desc',
		exclude_material_ids: options.excludeMaterialIds || undefined,
		limit: options.limit || undefined,
		voice_preset: options.voicePreset || undefined,
		dry_run: false,
	});
	return res.data;
}

export async function getBatchStatus(batchId) {
	const res = await workerXhr.get(`/batches/${batchId}`);
	return res.data;
}

export async function retryJob(jobId) {
	const res = await workerXhr.post(`/jobs/${jobId}/retry`);
	return res.data;
}

// Elimina un job del batch y de la cola. Si el job aún está corriendo, el
// backend lo desregistra del batch tracker sin cancelarlo (termina su ciclo
// natural pero deja de aparecer en la tabla).
// batch_id va como query param (no body) para evitar preflight CORS.
export async function deleteJob(jobId, batchId) {
	const params = batchId ? { batch_id: batchId } : undefined;
	await workerXhr.delete(`/jobs/${jobId}`, { params });
}

// Encola un job individual nuevo para el mismo material_id, con una
// audiencia (y por lo tanto voz) distinta — usado desde el botón
// "Regenerar con otra voz" en la tabla del batch.
export async function regenerateWithVoice(item, audienceTarget) {
	const payload = {
		mode: 'individual',
		material_id: item.material_id,
		program_type: item.program_type,
		context: item.context,
		topic: item.topic,
		audience_target: audienceTarget,
		script_override: null,
		metadata: {
			priority: 20, // regeneraciones manuales van casi al frente
			callback_url: CALLBACK_URL,
		},
	};
	const res = await workerXhr.post('/jobs', payload);
	return res.data;
}
